import { useSelector } from 'Hooks';

import { CURRENCY } from '../../__queries__/globalTypes';

// {new-country-onboarding} Add all new currencies here
const currencyToSymbolMap: Record<CURRENCY | string, string> = {
  [CURRENCY.DKK]: 'kr',
  [CURRENCY.EUR]: '€',
  [CURRENCY.NOK]: 'nkr',
  [CURRENCY.USD]: '$',
  [CURRENCY.SEK]: 'kr',
  [CURRENCY.GBP]: '£',
  TRY: '₺',
  AED: 'د.إ',
};

// {new-country-onboarding} Add all new currencies here
const currencyToLocaleMap: Record<CURRENCY | string, string> = {
  [CURRENCY.DKK]: 'da-DK',
  [CURRENCY.EUR]: 'nl-NL',
  [CURRENCY.NOK]: 'nb-NO',
  [CURRENCY.USD]: 'en-US',
  [CURRENCY.SEK]: 'sv-SE',
  [CURRENCY.GBP]: 'en-GB',
  TRY: 'tr-TR',
  AED: 'ar-AE',
};

// {new-country-onboarding} Add all new currencies here
const nonLegacyCurrencies: Record<string, string> = {
  TR: 'TRY',
  AE: 'AED',
};

const twoDecimalCurrencies = [CURRENCY.GBP, CURRENCY.EUR, 'TRY'];

export const useCurrency = () => {
  const companyData = useSelector((state) => state.companyData);
  const currency = companyData?.defaultCurrency || CURRENCY.SEK;
  const country = companyData?.country;

  const currencyType =
    country && nonLegacyCurrencies[country] ? nonLegacyCurrencies[country] : currency;

  const showTwoDecimals = twoDecimalCurrencies.includes(currencyType);

  const formatAmount = (amount: number): string => {
    // Guard, if the currency type is misstyped/is not supported
    if (!currencyType) {
      return (amount / 100).toString();
    }

    const formatter = new Intl.NumberFormat(currencyToLocaleMap[currencyType], {
      style: 'currency',
      currency: currencyType,
      minimumFractionDigits: showTwoDecimals ? 2 : 0,
      maximumFractionDigits: 2,
    });

    return formatter.format(amount / 100);
  };

  const symbol = (currencyCode?: CURRENCY) => {
    return country && nonLegacyCurrencies[country]
      ? currencyToSymbolMap[currencyType]
      : currencyToSymbolMap[currencyCode || currencyType];
  };

  return {
    formatAmount,
    symbol,
    code: currency,
  };
};
